import React, { Component } from 'react'

import ContMessageI18N from '../../containers/ContMessageI18N';
import IconRender from '../std/IconRender';

class FinanceFileButton extends Component {

	handleOpen = () => {
		this.props.onOpen();
	};

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	render() {
		var calculationResponse = this.props.vehicleDetails;
		return (
			<React.Fragment>
				{calculationResponse != null
					&& !calculationResponse.hasError
					&& calculationResponse.result != null
					&& <span data-bs-toggle="modal" data-bs-target="#modalFinanceFileGw">
						<button className='btn btn-link' onClick={() => { this.handleOpen() }}
							title='finance file'
						>
							<IconRender name="file-earmark-text" />
						</button>
					</span>
				}
			</React.Fragment>
		)
	}
}

export default (FinanceFileButton)


